import { FeaturesList } from '../../../../../../../../../shared/design-system/components/molecules/all-features-list-modal/types';
import { Placement } from '../../../../../../../../../shared/design-system/components/overlay';

const allFeatureAvailable = {
  starterFeatureMeta: {
    isAvailable: true,
  },
  professionalFeatureMeta: {
    isAvailable: true,
  },
  businessFeatureMeta: {
    isAvailable: true,
  },
  scalePlusFeatureMeta: {
    isAvailable: true,
  },
  customFeatureMeta: {
    isAvailable: true,
  },
};

const starterFeatureNotAvailable = {
  starterFeatureMeta: {
    isAvailable: false,
  },
  professionalFeatureMeta: {
    isAvailable: true,
  },
  businessFeatureMeta: {
    isAvailable: true,
  },
  scalePlusFeatureMeta: {
    isAvailable: true,
  },
  customFeatureMeta: {
    isAvailable: true,
  },
};

const higherLimit = 'Custom Limit';

export const getAllFeaturesList = (): FeaturesList[] => [
  {
    id: 1,
    title: '',
    features: [
      {
        featureId: 0,
        featureName: 'Unlimited Prospects',
        tooltipText:
          'Send unlimited emails to unlimited prospects and steps without paying extra.',
        ...allFeatureAvailable,
      },
      {
        featureId: 1,
        featureName: 'Unlimited Email Accounts',
        tooltipText:
          'Connect unlimited email account to your saleshandy account without paying extra',
        ...allFeatureAvailable,
      },
      {
        featureId: 2,
        featureName: 'Unlimited Team Members',
        tooltipText:
          'Invite unlimited team members to your Saleshandy account without paying extra.',
        ...starterFeatureNotAvailable,
      },
      {
        featureId: 3,
        featureName: 'Unlimited Sequences',
        tooltipText:
          'Create unlimited email sequences with no caps of steps & prospects',
        ...allFeatureAvailable,
      },
      {
        featureId: 4,
        featureName: 'Email Warm-up',
        tooltipText:
          'Email Warm-up is provided by our partner TrulyInbox. Sending is Subject to Fair Usage Policy',
        starterFeatureMeta: {
          text: 'Unlimited',
        },
        professionalFeatureMeta: {
          text: 'Unlimited',
        },
        businessFeatureMeta: {
          text: 'Unlimited',
        },
        scalePlusFeatureMeta: {
          text: 'Unlimited',
        },
        customFeatureMeta: {
          text: 'Unlimited',
        },
      },

      {
        featureId: 17,
        featureName: 'Unlimited 1:1 Email Tracking',
        tooltipText: 'Track unlimited emails from Gmail using chrome extension',
        ...allFeatureAvailable,
      },
      {
        featureId: 18,
        featureName: 'Sender Rotation',
        tooltipText:
          'Connect multiple email accounts to one sequence to rotate the senders automatically',
        starterFeatureMeta: {
          text: '10 Emails',
        },
        professionalFeatureMeta: {
          text: '50 Emails',
        },
        businessFeatureMeta: {
          text: '100 Emails',
        },
        scalePlusFeatureMeta: {
          text: '100 Emails',
        },
        customFeatureMeta: {
          text: 'Custom Limit',
        },
      },
      {
        featureId: 19,
        featureName: 'Unified Inbox',
        tooltipText:
          'Manage all mailbox replies for Saleshandy emails in one location',
        starterFeatureMeta: {
          text: 'Full Access',
        },
        professionalFeatureMeta: {
          text: 'Full Access',
        },
        businessFeatureMeta: {
          text: 'Full Access',
        },
        scalePlusFeatureMeta: {
          text: 'Full Access',
        },
        customFeatureMeta: {
          text: 'Full Access',
        },
      },
      {
        featureId: 10,
        featureName: 'A-Z Testing (Multivariant)',
        tooltipText:
          'Testing that allows you to make variants from A to Z in One Step to hyper personalize your sequence.',
        ...starterFeatureNotAvailable,
      },
      {
        featureId: 22,
        featureName: 'Subsequences',
        tooltipText: 'Send targeted follow-ups with conditions',
        ...starterFeatureNotAvailable,
      },
      {
        featureId: 20,
        featureName: 'Integrations',
        tooltipText:
          'Salesforce, Zapier, HubSpot, Pipedrive, Zoho Integrations',
        ...starterFeatureNotAvailable,
      },
      {
        featureId: 11,
        featureName: 'Spintax',
        tooltipText:
          'A spin syntax that allows you to generate different sentences with automatic keyword rotation.',
        ...allFeatureAvailable,
      },
      {
        featureId: 13,
        featureName: 'Advanced Warm-up Settings',
        ...starterFeatureNotAvailable,
      },
      {
        featureId: 6,
        featureName: 'Active Prospects',
        tooltipText: 'Number of prospects allowed in your account.',
        starterFeatureMeta: {
          text: '2,000',
        },
        professionalFeatureMeta: {
          text: '30,000',
        },
        businessFeatureMeta: {
          text: '60,000',
        },
        scalePlusFeatureMeta: {
          text: '70,000 - 500,000',
        },
        customFeatureMeta: {
          text: higherLimit,
        },
      },
      {
        featureId: 7,
        featureName: 'Monthly Emails',
        starterFeatureMeta: {
          text: '6,000',
          tooltipText: '6,000 limit is for Monthly/Yearly subscriptions.',
        },
        professionalFeatureMeta: {
          text: '150,000',
          tooltipText: '150,000 limit is for Monthly/Yearly subscriptions.',
        },
        businessFeatureMeta: {
          text: '240,000',
          tooltipText: '240,000 limit is for Monthly/Yearly subscriptions.',
        },
        scalePlusFeatureMeta: {
          text: '250,000 - 1,500,000',
        },
        customFeatureMeta: {
          text: higherLimit,
        },
      },
      {
        featureId: 8,
        featureName: 'Email Verification Credits',
        starterFeatureMeta: {
          text: '1,000',
          tooltipText:
            '1,000 credits are offered on Monthly/Annual subscriptions.',
        },
        professionalFeatureMeta: {
          text: '5,000',
          tooltipText:
            '5,000 credits are offered on Monthly/Annual subscriptions.',
        },
        businessFeatureMeta: {
          text: '10,000',
          tooltipText:
            '10,000 credits are offered on Monthly/Annual subscriptions.',
        },
        scalePlusFeatureMeta: {
          text: '10,000',
          tooltipText:
            '10,000 credits are offered on Monthly/Annual subscriptions.',
        },
        customFeatureMeta: {
          text: higherLimit,
        },
      },
      {
        featureId: 12,
        featureName: 'Advanced Reports',
        ...allFeatureAvailable,
      },
      {
        featureId: 15,
        featureName: '1:1 User Success Call',
        starterFeatureMeta: {
          isAvailable: false,
        },
        professionalFeatureMeta: {
          isAvailable: true,
        },
        businessFeatureMeta: {
          isAvailable: true,
        },
        scalePlusFeatureMeta: {
          isAvailable: true,
        },
        customFeatureMeta: {
          isAvailable: true,
        },
      },
      {
        featureId: 9,
        featureName: 'Dedicated Success Manager',
        ...starterFeatureNotAvailable,
        starterFeatureMeta: {
          isAvailable: false,
        },
        professionalFeatureMeta: {
          isAvailable: false,
        },
        businessFeatureMeta: {
          isAvailable: true,
        },
        scalePlusFeatureMeta: {
          isAvailable: true,
        },
        customFeatureMeta: {
          isAvailable: true,
        },
      },
      {
        featureId: 14,
        featureName: 'API',
        starterFeatureMeta: {
          isAvailable: true,
        },
        professionalFeatureMeta: {
          isAvailable: true,
        },
        businessFeatureMeta: {
          isAvailable: true,
        },
        scalePlusFeatureMeta: {
          isAvailable: true,
        },
        customFeatureMeta: {
          isAvailable: true,
        },
      },
      {
        featureId: 15,
        featureName: 'Agency Whitelabel',
        starterFeatureMeta: {
          isAvailable: false,
        },
        professionalFeatureMeta: {
          isAvailable: false,
        },
        businessFeatureMeta: {
          isAvailable: true,
        },
        scalePlusFeatureMeta: {
          isAvailable: true,
        },
        customFeatureMeta: {
          isAvailable: true,
        },
      },
      {
        featureId: 16,
        featureName: 'Lead Finder Credits',
        tooltipText:
          'These credits are available for first-time purchases and you can reveal Email and Phone numbers both.',
        tooltipPlacement: Placement.TopStart,
        starterFeatureMeta: {
          text: '50',
        },
        professionalFeatureMeta: {
          text: '100',
        },
        businessFeatureMeta: {
          text: '100',
        },
        scalePlusFeatureMeta: {
          text: '100',
        },
        customFeatureMeta: {
          text: higherLimit,
        },
      },
      {
        featureId: 17,
        featureName: 'Single Sign-on (SSO)',
        tooltipText:
          'SSO is available only for users on Scale and higher plans.',
        tooltipPlacement: Placement.TopStart,
        starterFeatureMeta: {
          isAvailable: false,
        },
        professionalFeatureMeta: {
          isAvailable: false,
        },
        businessFeatureMeta: {
          isAvailable: true,
        },
        scalePlusFeatureMeta: {
          isAvailable: true,
        },
        customFeatureMeta: {
          isAvailable: true,
        },
      },
      {
        featureId: 23,
        featureName: 'Inbox Radar',
        tooltipText:
          'Checks where your emails land (Inbox, Spam or Other tabs) across major email providers.',
        starterFeatureMeta: {
          isAvailable: false,
        },
        professionalFeatureMeta: {
          text: '1',
        },
        businessFeatureMeta: {
          text: '2',
        },
        scalePlusFeatureMeta: {
          text: '2',
        },
        customFeatureMeta: {
          text: higherLimit,
        },
      },
      {
        featureId: 24,
        featureName: 'AI Credits',
        starterFeatureMeta: {
          text: '100',
          tooltipText:
            '100 credits are offered on Monthly/Annual subscriptions.',
        },
        professionalFeatureMeta: {
          text: '200',
          tooltipText:
            '200 credits are offered on Monthly/Annual subscriptions.',
        },
        businessFeatureMeta: {
          text: '500',
          tooltipText:
            '500 credits are offered on Monthly/Annual subscriptions.',
        },
        scalePlusFeatureMeta: {
          text: '500',
          tooltipText:
            '500 credits are offered on Monthly/Annual subscriptions.',
        },
        customFeatureMeta: {
          text: higherLimit,
        },
      },
    ],
  },
];
